import React, { Component } from 'react';
import { func, objectOf, any, bool } from 'prop-types';
import { connectStateResults } from 'react-instantsearch-core';

class SearchStatePausable extends Component {
    static propTypes = {
        component: func.isRequired,
        keepSearchState: bool,
        keepSearchResults: bool,
        searchState: objectOf(any),
        searchResults: objectOf(any),
        allSearchResults: objectOf(any),
        error: objectOf(any),
        searching: bool,
        searchingForFacetValues: bool,
        isSearchStalled: bool,
    };

    static defaultProps = {
        searchState: {},
        keepSearchState: false,
        keepSearchResults: false,
        isSearchStalled: false,
        searchingForFacetValues: false,
        searchResults: null,
        allSearchResults: null,
        error: null,
        searching: false,
    };

    shouldComponentUpdate(nextProps) {
        return (
            !nextProps.searchState.manomano ||
            (nextProps.searchState.manomano &&
                (nextProps.searchState.manomano.targetOffset === undefined ||
                    nextProps.searchState.manomano.targetOffset ===
                        nextProps.searchState.configure.offset))
        );
    }

    getCleanedUpProps = () => {
        const {
            searchState,
            searchResults,
            allSearchResults,
            error,
            searching,
            searchingForFacetValues,
            isSearchStalled,
            keepSearchState,
            keepSearchResults,
            ...otherProps
        } = this.props;

        if (keepSearchState) {
            otherProps.searchState = searchState;
        }

        if (keepSearchResults) {
            otherProps.searchResults = searchResults;
        }

        return otherProps;
    };

    render() {
        const { component, ...otherProps } = this.getCleanedUpProps(this.props);
        return React.createElement(component, otherProps);
    }
}

const ConnectedSearchStatePausable = connectStateResults(SearchStatePausable);

export default ({
    keepSearchState,
    keepSearchResults,
}) => connectedComponent => props => (
    <ConnectedSearchStatePausable
        component={connectedComponent}
        keepSearchState={keepSearchState}
        keepSearchResults={keepSearchResults}
        {...props}
    />
);
